import { render, staticRenderFns } from "./TabsWithOneImageAndText.vue?vue&type=template&id=77235f9a&"
import script from "./TabsWithOneImageAndText.vue?vue&type=script&lang=ts&"
export * from "./TabsWithOneImageAndText.vue?vue&type=script&lang=ts&"
import style0 from "./TabsWithOneImageAndText.vue?vue&type=style&index=0&id=77235f9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports